import { Injectable, ɵConsole } from '@angular/core';
import { Headers, Http, RequestOptions, RequestOptionsArgs, ResponseContentType } from '@angular/http';
import { User } from '../models/user.model';
import { ApiConnectService } from './api-connect.service';
import * as moment from 'moment';
import { AnsweredQuestions } from '../models/answered-questions.model';
import { FabMessageService } from './fab-message.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { StepsControllerService } from './steps-controller.service';

@Injectable()
export class UserService {
  private timeUTC;

  constructor(private http: HttpClient,
    private fabService: FabMessageService,
    private apiURL: ApiConnectService) {
  }

  setLocal(user: User) {
    localStorage.setItem('User', JSON.stringify(user));
    // this.stepsControllerService.setLocalUserLang();
  }

  getSelf() {
    return this.http.get(this.apiURL.getSelf, { observe: 'response' });
  }

  getLocal(): User {
    return JSON.parse(localStorage.getItem('User'));
  }
 
  getUserLanguage() {
    const user = this.getLocal();
  }

  deleteLocal() {
    localStorage.removeItem('User');
  }

  getUserFromAPI(userID: string) {
    return this.http.get(this.apiURL.getUserById + userID, { observe: 'response' });
  }

  getUserFromAPINoSalary(userID: string) {
    return this.http.get(this.apiURL.getUserByIdNoSalary + userID, { observe: 'response' });
  }

  getClothes(userID) {
    return this.http.get(this.apiURL.getCloth + userID, { observe: 'response' });
  }

  getClothesPf(userID, description) {
    return this.http.post(this.apiURL.getClothPF + userID + '/?' + new HttpParams().set('description', description), { observe: 'response' });
  }

  biometrics(userID, one, two, three, four) {
    return this.http.post(this.apiURL.biometrics + userID + '?' + new HttpParams().set('growth', one).set('weight', two).set('clothingSize', three).set('shoeSize', four), { observe: 'response' });
  }

  getFile(fileId) {
    const requestOptions = {
      params: new HttpParams()
    };
    requestOptions.params.set('responseType', 'ResponseContentType.Blob');

    return this.http.get(this.apiURL.getFileById + fileId, { responseType: 'blob', observe: 'response' });
  }

  getTimezoneOffset() {
    if (moment().utcOffset() >= 0) {
      if (moment().utcOffset() / 60 < 10) {
        this.timeUTC = '+0' + moment().utcOffset() / 60 + ':00';
      } else {
        this.timeUTC = '+' + moment().utcOffset() / 60 + ':00';
      }
    } else {
      if (moment().utcOffset() / 60 > -10) {
        this.timeUTC = '-0' + (moment().utcOffset() / 60).toString().split('-')[1] + ':00';
      } else {
        this.timeUTC = moment().utcOffset() / 60 + ':00';
      }
    }
    return this.timeUTC;
  }


  writeLogoutTime() {
    // this.getTimezoneOffset();
    // const reqHeaders = new HttpHeaders({'offset': this.timeUTC});
    const reqHeaders = new HttpHeaders({ 'offset': this.getTimezoneOffset() });

    return this.http.post(this.apiURL.recordLogoutTime, null, { headers: reqHeaders });
  }

  getAllUsers() {
    return this.http.get(this.apiURL.getAllUsers, { observe: 'response' });
  }

  getActiveUsers() {
    const headers = new HttpHeaders({
      'status': 'ACTIVE'
    });

    return this.http.get(this.apiURL.getAllUsers, { headers: headers, observe: 'response' });
  }

  getUsersByIdGroup(id) {
    const headers = new HttpHeaders({
      'status': 'ACTIVE'
    });

    return this.http.get(this.apiURL.getGroupById + id + '/users', { headers: headers, observe: 'response' }); 
  }

  getReportByUserId(from: string, to: string, id: string) {
    const headers = new HttpHeaders({
      'from': from,
      'to': to
    });

    return this.http.get(this.apiURL.getUserReport + id + '/report', { headers: headers, observe: 'response' });
  }

  getReportStandartsUsers(id: string) {
    return this.http.get(this.apiURL.getListStandartsReport + id + '/details/standards', { responseType: 'text', observe: 'response' });
  }

  postVocation(params) {
    return this.http.post(this.apiURL.postVacation, params, { observe: 'response' });
  }

  getRequestOnProlong(from: string, to: string){
    const headers = new HttpHeaders({
      'from' : from,
      'to' : to
    });
    return this.http.get(this.apiURL.getRequestOnProlong, {headers: headers, observe: 'response'});
  }

  getVocation(id) {
    return this.http.get(this.apiURL.getVacation + id, { observe: 'response' });
  }

  getAllVacations(userId: string) {
    return this.http.get(this.apiURL.getUserVacations + userId + '/vacations', { observe: 'response' });
  }

  getReportByUserIdOff(from: string, to: string, id: string) {
    return this.http.post(this.apiURL.getUserReportOff + id + '?' + new HttpParams().set('data', from), { observe: 'response' });
  }

  getReportByGroupId(from: string, to: string, id: string) {
    const headers = new HttpHeaders({
      'from': from,
      'to': to
    });

    return this.http.get(this.apiURL.getGroupReport + id + '/report', { headers: headers, observe: 'response' });
  }

  getQuestions() {
    return this.http.get(this.apiURL.getQuestionsForCurrentUser, { observe: 'response' });
  }

  getQuestionsStep(sID) {
    return this.http.get(this.apiURL.getQuestionsForCurrentUserStep + sID + '/questions', { observe: 'response' });
  }

  checkAnswers(answers: AnsweredQuestions) {
    return this.http.post(this.apiURL.checkAnswersForTesting, answers, { observe: 'response' });
  }

  checkAnswersStep(sID, answers: AnsweredQuestions) {
    return this.http.put(this.apiURL.checkAnswersForTestingStep + sID + '/test', answers, { observe: 'response' });
  }

  // Methods for HEAD //

  // Get Head Standards
  getGroupHeadStandards() {
    let page: string;
    if (localStorage.getItem('lastPage')) {
      page = (Number(localStorage.getItem('lastPage')) - 1).toString();
    } else {
      page = '0';
    }
    const parameters = {
      page: page,
      sort: 'number,asc',
      size: '15',
      value: ''
    };

    const params = new HttpParams()
      .set('page', parameters.page)
      .set('sort', parameters.sort)
      .set('size', parameters.size)
      .set('value', parameters.value);

    return this.http.get(this.apiURL.getStandardsForGroupHead, { observe: 'response', params: params });
  }

  getGroupHeadStandards2() {
    let page: string;
    if (localStorage.getItem('lastPage2')) {
      page = (Number(localStorage.getItem('lastPage2')) - 1).toString();
    } else {
      page = '0';
    }
    const parameters = {
      page: page,
      sort: 'number,asc',
      size: '15',
      value: ''
    };

    const params = new HttpParams()
      .set('page', parameters.page)
      .set('sort', parameters.sort)
      .set('size', parameters.size)
      .set('value', parameters.value);

    return this.http.get(this.apiURL.getStandardsForGroupHead, { observe: 'response', params: params });
  }

  // Get HEAD standards by value (search)
  getHeadStandardsByValue(value) {
    const parameters = {
      page: '0',
      sort: 'number,asc',
      size: '15'
    };

    let params = new HttpParams()
      .set('page', parameters.page)
      .set('sort', parameters.sort)
      .set('size', parameters.size);

    if (value !== '') {
      params = params.set('value', value);
    }

    return this.http.get(this.apiURL.getStandardsByValueGroupHead, { observe: 'response', params: params });
  }

  // GET DATA FROM PAGE (HEAD)
  getPageAPIHead(searchValue, page, status, sortId) {
    if (localStorage.getItem('lastPage')) {
      page = (Number(localStorage.getItem('lastPage')) - 1).toString();
    } else {
      page = '0';
    }
    const parameters = {
      page: page,
      sort: sortId,
      size: '15',
    };

    let params = new HttpParams()
      .set('page', parameters.page)
      .set('sort', parameters.sort)
      .set('size', parameters.size);

    if (searchValue !== '') {
      params = params.set('value', searchValue);
    }

    if (status !== '') {
      params = params.set('status', status);
    }

    return this.http.get(this.apiURL.getStandardsByValueGroupHead, { observe: 'response', params: params });
  }

  getPageAPIHead2(searchValue, page, status, sortId) {
    if (localStorage.getItem('lastPage2')) {
      page = (Number(localStorage.getItem('lastPage2')) - 1).toString();
    } else {
      page = '0';
    }
    const parameters = {
      page: page,
      sort: sortId,
      size: '15',
    };

    let params = new HttpParams()
      .set('page', parameters.page)
      .set('sort', parameters.sort)
      .set('size', parameters.size);

    if (searchValue !== '') {
      params = params.set('value', searchValue);
    }

    if (status !== '') {
      params = params.set('status', status);
    }

    return this.http.get(this.apiURL.getStandardsByValueGroupHead, { observe: 'response', params: params });
  }

  // Get filtered standards (HEAD)
  getFilteredHeadStandards(searchValue, status) {
    const parameters = {
      page: '0',
      sort: 'number,asc',
      size: '15',
    };

    let params = new HttpParams()
      .set('page', parameters.page)
      .set('sort', parameters.sort)
      .set('size', parameters.size);

    if (searchValue !== '') {
      params = params.set('value', searchValue);
    }

    if (status !== '') {
      params = params.set('status', status);
    }

    return this.http.get(this.apiURL.getStandardsByValueGroupHead, { observe: 'response', params: params });
  }

  // GET SORTED LIST (HEAD)
  getSortedHeadList(page, sortId, searchValue, status) {
    const parameters = {
      page: page,
      sort: sortId,
      size: '15',
    };

    let params = new HttpParams()
      .set('page', parameters.page)
      .set('sort', parameters.sort)
      .set('size', parameters.size);

    if (searchValue !== '') {
      params = params.set('value', searchValue);
    }

    if (status !== '') {
      params = params.set('status', status);
    }

    return this.http.get(this.apiURL.getStandardsByValueGroupHead, { observe: 'response', params: params });
  }

  // Methods for USER //

  // GET STANDARDS FOR USER
  getStandards(userId: string) {
    const parameters = {
      page: '0',
      sort: 'number,asc',
      size: '15',
      value: ''
    };

    const params = new HttpParams()
      .set('page', parameters.page)
      .set('sort', parameters.sort)
      .set('size', parameters.size)
      .set('value', parameters.value);

    return this.http.get(this.apiURL.getStandardsForUser + userId + '/standards', { observe: 'response', params: params });
  }

  // SEARCH FOR VALUE (USER)
  searchForValue(userId: string, searchValue) {
    const parameters = {
      page: '0',
      sort: 'number,asc',
      size: '15',
      value: searchValue
    };

    const params = new HttpParams()
      .set('page', parameters.page)
      .set('sort', parameters.sort)
      .set('size', parameters.size)
      .set('value', parameters.value);

    return this.http.get(this.apiURL.getStandardsForUser + userId + '/standards', { observe: 'response', params: params });
  }

  // GET SORTED LIST (USER)
  getSortedList(userId: string, searchValue, sortId, page) {
    const parameters = {
      page: page,
      sort: sortId,
      size: '15',
      value: searchValue
    };

    const params = new HttpParams()
      .set('page', parameters.page)
      .set('sort', parameters.sort)
      .set('size', parameters.size)
      .set('value', parameters.value);

    return this.http.get(this.apiURL.getStandardsForUser + userId + '/standards', { observe: 'response', params: params });
  }

  // GET DATA FROM PAGE (USER)
  getPageServer(userId: string, searchValue, page, sortId) {
    const parameters = {
      page: page,
      sort: sortId,
      size: '15'
    };

    let params = new HttpParams()
      .set('page', parameters.page)
      .set('sort', parameters.sort)
      .set('size', parameters.size);

    if (searchValue !== '') {
      params = params.set('value', searchValue);
    }

    return this.http.get(this.apiURL.getStandardsForUser + userId + '/standards', { observe: 'response', params: params });
  }

  getPdf(pdfId: string) {
    return this.http.get(this.apiURL.getPdf + pdfId, { responseType: 'blob', observe: 'response' });
  }

  getBlanks(standardId: string) {
    const headers = new HttpHeaders({
      'id': standardId
    });

    return this.http.get(this.apiURL.getBlanks, { headers: headers, observe: 'response' });
  }

  doAcknowledgeWithStandard(standardID) {
    return this.http.post(this.apiURL.familiarizeWithStandard + standardID + '/read', null, { observe: 'response' });
  }

  doFamiliarizeWithStandard(standardID) {
    return this.http.post(this.apiURL.familiarizeWithStandard + standardID + '/familiarize', null, { observe: 'response' });
  }

  doApproved(standardID) {
    return this.http.post(this.apiURL.approvedStandard + standardID + '/confirm', null, { observe: 'response' });
  }

  doRequiresModification(standardID) {
    return this.http.post(this.apiURL.requiresModification + standardID + '/modify/request', null, { observe: 'response' });
  }


  getNotificationByID(notificationID) {
    return this.http.get(this.apiURL.getNotificationById + notificationID, { observe: 'response' });
  }

  getMyCreatedStandards() {
    const headers = new HttpHeaders({
      'Cache-Control': 'no-cache, no-store, must-revalidate',
    });
    return this.http.get(this.apiURL.getMyReport, { headers: headers, observe: 'response' });
  }

  deleteStandard(id) {
    const params = new HttpParams().set('id', id);

    return this.http.delete(this.apiURL.deleteStandard, {
      params: params,
      observe: 'response'
    });
  }

  deleteUserFromGroup(id, idGroup) {
    const params = new HttpParams()
      .set('idUser', id)
      .set('idGroup', idGroup);

    return this.http.delete(this.apiURL.deleteUser, {
      params: params,
      observe: 'response'
    });
  }

  getReportByGroupIdOff(groupId: string, date: string) {
  return this.http.post(
    this.apiURL.getGroupReportOff + groupId + '/dayoff?' + new HttpParams().set('data', date),
    null,
    { observe: 'response' }
  );
}

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/services/user.service.ts